<template>
    <f-dialog
        v-model       = "show"
        :width        = "modernization ? 1100 : 450"
        :hide-actions = "false"
        :show-header  = "true"
        :title        = "$t('unit.tzb.budget.title')"
        :show-save    = "true"
        @store        = "onStore"
        @cancel       = "onCancel"
    >
        <template v-slot:content>
            <v-row dense class="pt-3">
                <v-col>
                    <f-enum-select
                        v-model       = "tzb.measure"
                        :label        = "$t('unit.tzb.budget.unit.measure')"
                        class         = "measure-type"
                        module        = "msd"
                        type          = "tzbUnitMeasure"
                        :hide-details = "true"
                    />
                </v-col>
                <v-col>
                    <div class="mb-2" v-if="!modernization">
                        <f-currency-field
                            :label        = "$t('unit.tzb.budget.unit.budget')"
                            v-model       = "tzb.costs"
                            class         = "money measure-costs"
                            :readonly     = "!unitMeasure"
                        />
                    </div>
                </v-col>
                <v-col v-if="modernization">

                </v-col>
            </v-row>
            <v-row dense class="pt-1" v-if="!modernization">
                <v-col>
                    <v-textarea
                        :label         = "$t('unit.tzb.budget.unit.comment')"
                        v-model        = "tzb.comment"
                        rows           = "4"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        hide-details   = "true"
                        no-resize
                    />
                </v-col>
            </v-row>
            <v-row dense class="pt-3" v-if="modernization">
                <v-col>
                    <p-site-tzb-calculation-component
                        :title  = "$t('unit.tzb.engine.title')"
                        :tzb-component = "tzb.engine"
                    />
                </v-col>
                <v-col>
                    <p-site-tzb-calculation-component
                        :title  = "$t('unit.tzb.automatic.title')"
                        :tzb-component = "tzb.automatic"
                    />
                </v-col>
                <v-col>
                    <p-site-tzb-calculation-component
                        :title  = "$t('unit.tzb.control.title')"
                        :tzb-component = "tzb.control"
                    />
                </v-col>
            </v-row>
            <v-row dense class="pt-3" v-if="modernization">
                <v-col>
                    <p-site-tzb-calculation-component
                        :title  = "$t('unit.tzb.manholeDoor.title')"
                        :tzb-component = "tzb.liftShaftDoor"
                    />
                </v-col>
                <v-col>
                    <p-site-tzb-calculation-component
                        :title  = "$t('unit.tzb.car.title')"
                        :tzb-component = "tzb.car"
                    />
                </v-col>
                <v-col>
                    <p-site-tzb-calculation-component
                        :title  = "$t('unit.tzb.speedLimiter.title')"
                        :tzb-component = "tzb.speedLimiter"
                    />
                </v-col>
            </v-row>
            <v-row dense class="pt-3" v-if="modernization">
                <v-col>
                    <p-site-tzb-calculation-component
                        :title  = "$t('unit.tzb.saftyCatch.title')"
                        :tzb-component = "tzb.saftyCatch"
                    />
                </v-col>
                <v-col>
                    <p-site-tzb-calculation-component
                        :title  = "$t('unit.tzb.doorDrive.title')"
                        :tzb-component = "tzb.doorDrive"
                    />
                </v-col>
                <v-col>
                    <p-site-tzb-calculation-component
                        :title  = "$t('unit.tzb.emcSystem.title')"
                        :tzb-component = "tzb.emcSystem"
                    />
                </v-col>
            </v-row>
        </template>
    </f-dialog>
</template>

<script>

import FDialog from "@/modules/core/components/utils/FDialog.vue";
import PSiteTzbCalculationComponent from "@/modules/msd/unit/components/dialog/private/PSiteTzbCalculationComponent.vue";
import FCurrencyField from "@/modules/core/components/utils/FCurrencyField.vue";
import FEnumSelect from "@/modules/core/components/utils/FEnumSelect.vue";
import Site from "@/modules/msd/unit/service/Site";
import Core from "@/modules/core/service/Core";

export default {
    name: "PSiteTzbCalculation",

    components: {
        FEnumSelect,
        FCurrencyField,
        PSiteTzbCalculationComponent,
        FDialog
    },
    props: {
        value: {

        },

        unitId: {

        },

        tzb: {
        }
    },

    data: () => ({
        show : false,
    }),

    computed: {
        modernization () {
            if (!this.tzb.measure) {
                return false
            }

            return this.tzb.measure.id === 4;
        },

        unitMeasure () {
            if (!this.tzb.measure) {
                return false
            }

            return this.tzb.measure.id === 2 || this.tzb.measure.id === 3;
        },
    },

    mounted() {
        this.show = this.value;
        if (this.show) {
            this.load();
        }
    },

    watch: {
        value () {
            this.show = this.value;
            if (this.show) {
                this.load();
            }
        }
    },

    methods: {
        async load () {
        },

        onStore () {
            Site.condition.save(this.unitId, this.tzb.id, this.tzb).then(() => {
                Core.message.alert.save(this);
                this.onCancel();
            })
        },

        onCancel () {
            this.$emit("input", false);
        },
    }
}
</script>

<style scoped>
.money ::v-deep input{
    text-align: right;
}

</style>